declare global {
  interface Window {
    isMainTabHidden?: boolean;
  }
}

/**
 * This utils allows us to check whether customer have changed tabs
 * at some point using the Page Visiblity API. We are using these utils
 * to ensure we are reporting correct Time to Designer Interactive metrics.
 *
 * Browsers typically have a number of policies in place to mitigate the
 * performance impact of background or hidden tabs. These include things
 * like clamping timeouts to a minimum, stop sending requestAnimationFrame,
 * among others (1).
 *
 * What these policies mean is that browsers are really slow on inactive tabs,
 * which means that if customers start loading the Designer, go to another
 * tab and after a while they come back again to the Designer, the loading
 * times and other performance readings will be seriously skewed.
 *
 * 1. https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API#policies_in_place_to_aid_background_page_performance
 */

// We consider the main tab to have been unfocused if it was on document
// load, or if it is when we kickstart this.
let tabHasBeenUnfocused =
  (typeof window !== 'undefined' && window.isMainTabHidden) ||
  (typeof document !== 'undefined' && document.hidden) ||
  false;

const handleVisibilityChange = () => {
  if (tabHasBeenUnfocused) return;

  tabHasBeenUnfocused = true;
};

const listenToTabFocusUpdates = () => {
  document.addEventListener('visibilitychange', handleVisibilityChange);
};

const hasTabBeenUnfocused = () => {
  document.removeEventListener('visibilitychange', handleVisibilityChange);

  return tabHasBeenUnfocused;
};

export {hasTabBeenUnfocused, listenToTabFocusUpdates};
